import { render } from "./LoadingPlaceholder.vue?vue&type=template&id=43f70cfb&scoped=true"
import script from "./LoadingPlaceholder.vue?vue&type=script&lang=js"
export * from "./LoadingPlaceholder.vue?vue&type=script&lang=js"

import "./LoadingPlaceholder.vue?vue&type=style&index=0&id=43f70cfb&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43f70cfb"]])

export default __exports__